import { connect } from "react-redux";
import QuickFavourites from "../components/QuickFavourites";
import { isSlideAvailable, getTrackableSlidesInChapter, getSlideIndex } from "../utils/helpers";
import { toggleFavorite, goToSlide, setUIVisibilityState } from "../actions";
var mapStateToProps = function(state, _) {
    var _state_cbook;
    return {
        iconURL: (_state_cbook = state.cbook) === null || _state_cbook === void 0 ? void 0 : _state_cbook.icon_url,
        visible: state.uiVisibilityState.quickFavourites,
        quick_nav_cont: state.cbook && state.cbook.quick_nav_cont,
        quick_nav_background_image: state.cbook && state.cbook.quick_nav_background_image,
        nodes: state.nodes,
        claims: state.cbook && state.claims && state.claims[state.cbook.id],
        currentSlide: state.currentSlide,
        favorites: state.favorites,
        completedSlides: state.completed,
        quickFavOrigin: state.quickFavOriginSlide,
        isComplete: function(id) {
            return state.completed.indexOf(id) > -1;
        },
        getSlideStatus: function(id) {
            return state.api ? state.api.getSlideStatus(id) : "";
        },
        isAvailable: function(slide) {
            return isSlideAvailable(slide, state);
        },
        isChapterAvailable: function(chapter) {
            return state.nodes.filter(function(n) {
                return chapter.c.indexOf(n.id) > -1;
            }).some(function(n) {
                return isSlideAvailable(n, state);
            });
        },
        getChapterIndex: function(chapter) {
            return getChapterIndex(chapter, state);
        },
        getSlideIndex: function(id) {
            return getSlideIndex(id, state);
        },
        isFavorite: function(id) {
            return state.favorites.indexOf(id) > -1;
        },
        trackableSlidesInChapter: function(chapter) {
            return getTrackableSlidesInChapter(chapter, state);
        }
    };
};
var mapDispatchToProps = function(dispatch) {
    return {
        toggleFavorite: function(id) {
            dispatch(toggleFavorite({
                id: id
            }));
        },
        goTo: function(id, localId, quickFavOrigin) {
            dispatch(goToSlide({
                id: id,
                localId: localId,
                quickFavOrigin: quickFavOrigin
            }));
        },
        setUIVisibilityState: function(state) {
            return dispatch(setUIVisibilityState({
                state: state
            }));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(QuickFavourites);
export function getChapterIndex(chapter, state) {
    var path = [
        chapter.id
    ];
    function getChapterPath(_chapter) {
        var nodeParent = state.nodes.find(function(n) {
            return n.c && n.c.includes(_chapter.id);
        });
        if (nodeParent) {
            path.push(nodeParent.id);
            getChapterPath(nodeParent);
        }
    }
    getChapterPath(chapter);
    path = path.reverse();
    var chapterIndex = path.map(function(p, i) {
        if (i === 0) {
            var rootIndex = state.cbook.c.indexOf(p);
            return rootIndex + 1;
        }
        var index = state.nodes.find(function(n) {
            return n.id === path[i - 1];
        }) // current chapter's parent
        .c // all parent chapter's childern ids
        .map(function(c) {
            return state.nodes.find(function(n) {
                return n.id === c;
            });
        }) // all parent chapter's childern
        .filter(function(n) {
            return n.target_type === "Filter";
        }) // filter for chapter nodes
        .findIndex(function(n) {
            return n.id === p;
        });
        return index + 1;
    });
    return chapterIndex;
}
